import { useEffect, useMemo } from 'react'
import useEnrichedLineItems from '@lib/hooks/use-enrich-line-items'
import DiscountCode from '@modules/checkout/components/discount-code'
import SkeletonCartPage from '@modules/skeletons/templates/skeleton-cart-page'
import { useCart, useMeCustomer } from 'medusa-react'
import EmptyCartMessage from '../components/empty-cart-message'
import SignInPrompt from '../components/sign-in-prompt'
import ItemsTemplate from './items'
import Summary from './summary'
import { canBuy } from '@lib/util/can-buy'
import useGA4DataLayer from '@common/hooks/use-ga4-data-layer'
import useListenCartChange from '@common/hooks/use-listen-cart-change'
import Avocado from '@modules/checkout/components/avocado'

const CartTemplate = () => {
  const { cart } = useCart()
  const { customer, isLoading } = useMeCustomer()
  const items = useEnrichedLineItems()
  const { viewCartTag, viewPromotionTag, selectPromotionTag } =
    useGA4DataLayer()

  useListenCartChange()

  useEffect(() => {
    if (cart != null) {
      viewCartTag(
        cart.region?.currency_code ?? 'sgd',
        (cart.total ?? 0) / 100,
        cart.items
      )
      viewPromotionTag(cart.items, (cart as any).promotions, cart.discounts)
      selectPromotionTag(cart.items, (cart as any).promotions, cart.discounts)
    }
  }, [cart])

  const isOutOfStock = useMemo(() => {
    if (items) {
      const itemsOutOfStock = items.filter((item) => !canBuy(item.variant))

      if (itemsOutOfStock.length > 0) {
        return true
      }
    }
    return false
  }, [items])

  if (!cart || !cart?.id?.length || isLoading) {
    return <SkeletonCartPage />
  }

  return (
    <div className="py-12 bg-gray-50">
      <div className="content-container">
        {cart.items.length ? (
          <div className="grid grid-cols-1 small:grid-cols-[1fr_400px] gap-x-8">
            <div className="flex flex-col p-6 bg-white gap-y-6">
              {!customer && <SignInPrompt />}
              <ItemsTemplate region={cart?.region} items={items} />
            </div>
            <div className="relative">
              <div className="sticky flex flex-col gap-y-8 top-12">
                {cart && cart.region && (
                  <>
                    <div className="p-6 bg-white">
                      <Summary isOutOfStock={isOutOfStock} cart={cart} />
                    </div>
                    <Avocado />
                    <div className="p-6 bg-white">
                      <DiscountCode cart={cart} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div>
            {!customer && <SignInPrompt />}
            <EmptyCartMessage />
          </div>
        )}
      </div>
    </div>
  )
}

export default CartTemplate
